import { createSlice } from '@reduxjs/toolkit'

export const LoginNewSlice = createSlice({
  name: 'loginNew',
  initialState: {
    open: false,
    tab: 1,
    isLanguage: false,
    language: 'en',
    isNotificationOpen: false,
  },
  reducers: {
    setLoginNew: (state, action) => ({ ...state, open: action.payload, tab: 1}),
    setTab: (state, action) => ({ ...state, tab: action.payload }),
    setIsLangauage: (state, action) => ({ ...state, isLanguage: action.payload }),
    setLangauage: (state, action) => ({ ...state, language: action.payload }),
    setIsNotificationOpen: (state, action) => ({ ...state, isNotificationOpen: action.payload }),
  },
})

export const { setLoginNew, setTab, setIsLangauage, setLangauage, setIsNotificationOpen } = LoginNewSlice.actions

export default LoginNewSlice.reducer
